/**
 * Centralized limits registry for the application.
 * These limit keys are checked against organization's subscription plan limits.
 * Used to enforce usage caps and display appropriate warnings/blocks when limits are reached.
 *
 * Usage:
 * - Import: import { LIMITS } from '@/access/limits'
 * - Check limits in store or components via plan/usage tracking
 * - Used with UsageLimitCheck/UsageLimitsModal and plan overage warnings
 */
export const LIMITS = Object.freeze({
  // Core Entity Limits
  CAMPAIGNS: 'campaigns',
  GROUPS: 'groups',
  AUTOMATIONS: 'automations',
  EMAILS: 'emails',
  USERS: 'users',
  CONTACTS: 'contacts',

  // Communication Limits
  MAL: 'mal', // Monthly Active Learners
  SMS: 'sms',
  SMS_REGISTRATION: 'sms_registration',

  // Content & Media Limits
  VIDEO_UPLOAD: 'video_upload',
  PORTAL_SEARCH: 'portal_search',

  // Workflow Limits
  WORKFLOWS: 'workflows',
  WORKFLOW_SIZE: 'workflow_size',

  // Organization Limits
  TEAMS: 'teams',
  CUSTOM_OBJECTS: 'custom_objects',
  CUSTOM_RECORDS: 'custom_records',
});
